import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import BaseNotificationsRecepients from '../../AbstractObjects/GatewayPlan/InnerPages/BaseNotificationsRecepients';

const pageSchema = GatewayGetSchema.pages.notificationsRecipients;
const pageId = pageSchema.pageId;

function PlanNotificationsRecipients({
    planObject,
    setPlanData
}) {
    let pageData = planObject[pageId];
    
    return (
        <BaseNotificationsRecepients
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanNotificationsRecipients;